import type { EmAttachment } from './types';

const IMAGE_EXT = new Set(['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'svg']);

export function isImageContentType(contentType?: string): boolean {
  return !!contentType && contentType.startsWith('image/');
}

export function isImageAttachment(name: string, contentType?: string): boolean {
  if (isImageContentType(contentType)) return true;
  const ext = name.split('.').pop()?.toLowerCase();
  return ext != null && IMAGE_EXT.has(ext);
}

export function attachmentFileExtension(name: string): string {
  const dot = name.lastIndexOf('.');
  if (dot < 0 || dot === name.length - 1) return 'FILE';
  return name.slice(dot + 1).toUpperCase().slice(0, 8);
}

export function resolveAttachmentMessageId(attachment: EmAttachment, fallbackMessageId: string): string {
  return attachment.messageId ?? fallbackMessageId;
}
